import { render } from "./ProsesRegulasi.vue?vue&type=template&id=26747e00"
import script from "./ProsesRegulasi.vue?vue&type=script&lang=js"
export * from "./ProsesRegulasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__